import React, { AnchorHTMLAttributes, forwardRef } from 'react'
import { StrictOmit } from './strictOmit'

export type LinkProps = {
  external: boolean
  url: string
} & StrictOmit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'>

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ external, ...rest }, ref) =>
  external ? <ExternalLink ref={ref} {...rest} /> : <InternalLink ref={ref} {...rest} />
)

export const InternalLink = forwardRef<HTMLAnchorElement, StrictOmit<LinkProps, 'external'>>(
  ({ url, onClick, ...rest }, ref) => (
    <a
      ref={ref}
      href={url}
      onClick={(event) => {
        event.preventDefault()
        navigate(url)
        if (onClick !== undefined) onClick(event)
      }}
      {...rest}
    />
  )
)

export const navigate = (to: string) => window.history.pushState({}, '', to)

export const ExternalLink = forwardRef<HTMLAnchorElement, StrictOmit<LinkProps, 'external'>>(
  ({ url, children, ...rest }, ref) => (
    <a ref={ref} {...rest} target="_blank" rel="noopener noreferrer" href={url}>
      {children}
      <span className="sr-text"> (opens in new tab)</span>
    </a>
  )
)
